const PageLayoutContentOnly = ({ children }) => <>{children}</>

export default PageLayoutContentOnly
